import React, { useCallback, useMemo, useState } from "react";
import "./RouletteLayoutMobile.scss";
import swal from "sweetalert";
import moment from "moment";
import RouletteWheelMobile from "./RouletteWheelMobile";
import RouletteBettingBoardMobile from "./RouletteBettingBoardMobile";
import { env } from "../../../env";
import LoadingGif from "../../../utils/LoadingGif";
import DatetimeContainer from "../../date/DatetimeContainer";
import RecentOrdering from "../RecentOrdering";
import _ from "lodash";
import CountDownTimerMobile from "./CountDownTimerMobile";
import useMobileViewport from "./useMobileViewport";
import BettingDialog from "../../lotto5/BettingDialog";
import {isProvider} from "../../../utils/storage";

const initialBetState = {
    showDeleteBetting: false,
    showBetting: false,
    betCode: "",
    betAmount: 0,
    betGameType: "",
    betGameOdds: "",
    betGameRange: "",
    betGameTime: "",
    betMessage: "",
    isShowValidateBalance: false,
    messageValidateBalance: null,
    isEnableBetNow: true,
};

const RouletteLayoutMobile = (props) => {
    useMobileViewport();

    const {
        t,
        config,
        user,
        draw,
        newResult,
        isStopBet,
        addRouletteBetting,
        rouletteConfirmBettingNow,
        fetchRouletteRecentBetReport,
        fetchUserBalance,
        fetchRouletteListBetting,
        fetchUserBalanceValidate,
        underOverCode,
        oddEvenCode,
        colorCode,
        result,
        drawLabel,
        betting,
        appClass
    } = props;

    const {
        user: { isAddToCart },
    } = props;

    const countDownTimer = draw?.countDownTimer ?? 0;
    const totalResult = draw?.totalResult ?? 0;
    const drawCode = draw?.newResult?.drawCode ?? draw?.oldResult?.drawCode ?? "";

    const [betState, setBetState] = useState(initialBetState);

    const {
        showBetting,
        betCode,
        betAmount,
        betGameType,
        betGameOdds,
        betGameRange,
        betGameTime,
        betMessage,
        isShowValidateBalance,
        messageValidateBalance,
        isEnableBetNow,
    } = betState;

    const resetBetForm = useCallback(() => {
        setBetState((prev) => ({
            ...prev,
            showBetting: false,
            betCode: "",
            betAmount: 0,
            betGameType: "",
            betGameOdds: "",
            betGameRange: "",
            betGameTime: "",
            betMessage: "",
        }));
    }, []);

    const onCancelBetting = useCallback(() => {
        resetBetForm();
    }, [resetBetForm]);

    const clickAmountBetBtn = useCallback((amount) => {
        setBetState((prev) => ({
            ...prev,
            betAmount: parseInt(prev.betAmount || 0, 10) + amount,
        }));
    }, []);

    const resetDefaultAmount = useCallback(() => {
        setBetState((prev) => ({
            ...prev,
            betAmount: 0,
        }));
    }, []);

    const changeBetAmount = useCallback((e) => {
        const value = e.target.value;

        if (value >= 0 || !isNaN(value) || value === undefined) {
            setBetState((prev) => ({
                ...prev,
                betAmount: value,
            }));
        }
    }, []);

    const isValidBetAmount = useCallback(
        (amount = 0) => {
            const parsedAmount = parseInt(amount, 10);

            if (Number.isNaN(parsedAmount)) {
                return false;
            }

            const { maxBet, minBet } = config.limit;
            return !(parsedAmount < minBet || parsedAmount > maxBet);
        },
        [config]
    );

    const submitBetNow = useCallback(
        (isPrint) => {
            if (!isEnableBetNow) return;

            rouletteConfirmBettingNow(() => {
                setBetState((prev) => ({
                    ...prev,
                    isEnableBetNow: false,
                }));
            })
                .then(() => {
                    fetchRouletteRecentBetReport().then(() => {
                        if (isPrint) {
                            const printButton = document.getElementById("print-button");
                            if (printButton) {
                                printButton.click();
                            }
                        }
                    });

                    fetchUserBalance();

                    setBetState((prev) => ({
                        ...prev,
                        isEnableBetNow: true,
                    }));
                })
                .catch((error) => {
                    setBetState((prev) => ({
                        ...prev,
                        isEnableBetNow: true,
                    }));

                    const message =
                        error?.response?.data?.message || error?.message || "Bet failed";

                    swal(message, { icon: "error", button: "បិទ" });
                });
        },
        [
            isEnableBetNow,
            rouletteConfirmBettingNow,
            fetchRouletteRecentBetReport,
            fetchUserBalance,
        ]
    );

    const onConfirmBetting = useCallback(
        async (logs) => {
            const { userBalance, isAddToCart, isAutoPrint } = user;

            const totalCartAmount = fetchRouletteListBetting({ isClear: false }) || 0;
            const parsedBetAmount = parseInt(betAmount || 0, 10);

            if (!isValidBetAmount(parsedBetAmount)) {
                setBetState((prev) => ({
                    ...prev,
                    betMessage: t("labels:keno.requireAmount"),
                }));
                return;
            }

            if (!isProvider && (totalCartAmount + parsedBetAmount > userBalance.balance)) {
                setBetState((prev) => ({
                    ...prev,
                    betMessage: t("labels:common.NOT_ENOUGH_BALANCE"),
                }));
                return;
            }

            const data = {
                drawCode: newResult?.drawCode,
                betTypeCode: betCode,
                amount: parsedBetAmount,
                betLog: logs,
                rebateRate: betGameOdds,
            };

            await addRouletteBetting(data);

            if (!isAddToCart) {
                submitBetNow(isAutoPrint);
            }

            setBetState((prev) => ({
                ...prev,
                showBetting: false,
                betAmount: 0,
                betGameType: "",
                betGameOdds: "",
                betCode: "",
                betGameRange: "",
                betGameTime: "",
                betMessage: null,
            }));
        },
        [
            user,
            fetchRouletteListBetting,
            betAmount,
            isValidBetAmount,
            t,
            newResult,
            betCode,
            betGameOdds,
            addRouletteBetting,
            submitBetNow,
        ]
    );

    const onBetting = useCallback(
        (item) => {
            if (isStopBet) return;

            fetchUserBalanceValidate()
                .then(() => {
                    setBetState((prev) => ({
                        ...prev,
                        showBetting: true,
                        betGameType: item.name,
                        betGameOdds: item.value,
                        betGameRange: item.resultRange,
                        betCode: item.code,
                        betGameTime: moment().format("HH:mm:ss"),
                        betMessage: "",
                        isShowValidateBalance: false,
                        messageValidateBalance: null,
                    }));
                })
                .catch((error) => {
                    setBetState((prev) => ({
                        ...prev,
                        isShowValidateBalance: true,
                        messageValidateBalance: t(
                            "labels:common." + error?.response?.data?.message
                        ),
                    }));
                });
        },
        [isStopBet, fetchUserBalanceValidate, t]
    );

    const headerResultText = useMemo(() => {
        if (!(underOverCode && oddEvenCode)) return "";

        return (
            t("labels:betPrefix." + underOverCode) +
            " / " +
            t("labels:betPrefix." + oddEvenCode) +
            " / " +
            t("labels:betPrefix." + colorCode) +
            " / " +
            result
        );
    }, [underOverCode, oddEvenCode, colorCode, result, t]);

    return (
        <div className="rml-page rml-roulette-page">
            <div className="rml-layout">
                <div className="rml-layout__body">
                    <section className="rml-wheel-card">
                        <header className={`rml-header platform-${env.PLATFORM_FOR}`}>
                            <div className="rml-roulette-title">ឆ្នោត 1/36</div>

                            <div className="rml-header__left">
                                <div className="rml-header__item">{drawLabel}</div>

                                <div className="rml-header__item rml-header__item--result">
                                    {headerResultText || ""}
                                </div>

                                <div className="rml-header__item">
                                    <LoadingGif className="rml-header__loading" />
                                    <span>
                    {newResult !== null
                        ? newResult?.drawLabel
                        : t("labels:upcoming_draw")}
                  </span>
                                </div>
                            </div>

                            <div className="rml-header__right">
                                <DatetimeContainer />
                            </div>
                        </header>

                        <div className="rml-wheel-stage">
                            <RouletteWheelMobile {...props} />
                            <div className="rml-wheel-stage__countdown">
                                <CountDownTimerMobile
                                    countDownTimer={countDownTimer}
                                    totalResult={totalResult}
                                    drawCode={drawCode}
                                    onLastTenSecond={props.onLastTenSecond}
                                    onCancelBetting={onCancelBetting}
                                />
                            </div>
                        </div>
                    </section>

                    <RouletteBettingBoardMobile {...props} onBetting={onBetting} />
                </div>

                {!_.isEmpty(betting?.betList) && isAddToCart && (
                    <div className="rml-recent-ordering">
                        <RecentOrdering {...props} />
                    </div>
                )}
            </div>

            <div className="modal-mobile">
                <BettingDialog
                    {...props}
                    appClass={appClass}
                    changeBetAmount={changeBetAmount}
                    clickAmountBetBtn={clickAmountBetBtn}
                    onConfirmBettingLotto5={onConfirmBetting}
                    resetDefaultAmount={resetDefaultAmount}
                    onCancelBetting={onCancelBetting}
                    showBetting={showBetting}
                    betCode={betCode}
                    betAmount={betAmount}
                    betGameType={betGameType}
                    betGameOdds={betGameOdds}
                    betGameRange={betGameRange}
                    betGameTime={betGameTime}
                    betMessage={betMessage}
                    isShowValidateBalance={isShowValidateBalance}
                    messageValidateBalance={messageValidateBalance}
                    isEnableBetNow={isEnableBetNow}
                    classDialog="bet-mix-dialog"
                />
            </div>
        </div>
    );
};

export default RouletteLayoutMobile;